import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import Skeleton from '@material-ui/lab/Skeleton';

function LoadingView(props) {
  const textLine = (
    <div className="w-100 py-2">
      <Skeleton variant="text"/>
    </div>
  );

  return (
    <>
      <div className="col-12 col-md-6">
        <div className="card-header">
          <div className="card-title"><Translate value="globalDashboard.documents"/></div>
        </div>
        <>
          <div className="percentages-legend mb-5 w-100">
            {textLine}
            {textLine}
            {textLine}
          </div>
          {props.actions}
        </>
      </div>
      <div className="col-12 col-md-6 flex-container column center pt-4">
        <Skeleton
          variant="circle"
          height={171}
          width={171}
        />
      </div>
    </>
  );
}

LoadingView.propTypes = {
  actions: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export default LoadingView;
